// src/Components/BankingReconciliation/components/PortfolioNetBalance.jsx
import React from "react";
import Styles from "./PortfolioNetBalance.module.css";
import { formatInr, signed } from "../../utils/reconFormat";

const PortfolioNetBalance = ({ portfolio }) => {
  const { scheduled, actual, netBalance, drawnPct } = portfolio;
  return (
    <section className={Styles.card}>
      <div className={Styles.topRow}>
        <span className={Styles.label}>PORTFOLIO NET BALANCE</span>
        <div className={Styles.pills}>
          <span className={Styles.injPill}>Scheduled {formatInr(scheduled)}</span>
          <span className={Styles.arrow}>→</span>
          <span className={Styles.bfPill}>Actual {formatInr(actual)}</span>
        </div>
      </div>

      <div className={Styles.bigValue}>
        {signed(netBalance)} <span className={Styles.unit}>MWh</span>
      </div>
      <div className={Styles.caption}>{formatInr(netBalance)} MWh remaining to be drawn</div>

      <div className={Styles.barTrack}>
        <div className={Styles.barFill} style={{ width: `${drawnPct}%` }} />
        <span className={Styles.barPct}>{drawnPct}% drawn</span>
      </div>

      <div className={Styles.miniStats}>
        <div className={Styles.mini}>
          <span className={`${Styles.dot} ${Styles.dotDrawn}`} />
          <div>
            <div className={Styles.miniLabel}>ACTUAL</div>
            <div className={Styles.miniValue}>{formatInr(actual)} <em>MWh · {drawnPct}%</em></div>
          </div>
        </div>
        <div className={Styles.mini}>
          <span className={`${Styles.dot} ${Styles.dotRemain}`} />
          <div>
            <div className={Styles.miniLabel}>REMAINING</div>
            <div className={Styles.miniValue}>{signed(netBalance)} <em>MWh</em></div>
          </div>
        </div>
        <div className={Styles.mini}>
          <div>
            <div className={Styles.miniLabel}>SCHEDULED</div>
            <div className={Styles.miniValue}>{formatInr(scheduled)} <em>MWh</em></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioNetBalance;
